"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCategoryGroupListsSuccessActionWatcher = exports.getCategoryGroupListsSuccessActionWatcher = exports.createCategoryGroupListsActionWater = void 0;
const effects_1 = require("redux-saga/effects");
const categoryGroupListsSelectors_1 = require("companion-app-components/flux/category-group-lists/categoryGroupListsSelectors");
const categoryGroupListsActions_1 = require("companion-app-components/flux/category-group-lists/categoryGroupListsActions");
const core_1 = require("companion-app-components/flux/core");
const auth_1 = require("companion-app-components/flux/auth");
const actions = __importStar(require("data/categoryGroupLists/categoryGroupListsActions"));
const mkResourceConfig = (props) => core_1.resourceStoreTypes.mkQcsSyncResourceConfig(Object.assign({ resourceName: 'categoryGroupLists', resourceBaseUrl: '/category-group-lists', getLastSyncDate: categoryGroupListsSelectors_1.getLastSyncDate }, props));
function* createCategoryGroupListsActionWater() {
    const config = mkResourceConfig({
        successAction: actions.createCategoryGroupListsSuccessAction,
        failureAction: actions.createCategoryGroupListsFailureAction,
    });
    yield (0, effects_1.takeEvery)(actions.createCategoryGroupListsAction.type, core_1.resourceSagaUtils.qcsSyncCreateResource, config);
}
exports.createCategoryGroupListsActionWater = createCategoryGroupListsActionWater;
function* createCategoryGroupLists({ payload }) {
    const categoryGroupListsFetched = yield (0, effects_1.select)(categoryGroupListsSelectors_1.getCategoryGroupLists);
    const isWebFirstDataset = yield (0, effects_1.select)(auth_1.authSelectors.getIsWebfirstDataset);
    if (categoryGroupListsFetched.size === 0 && isWebFirstDataset) {
        if (payload.resources.length === 0) {
            const actionPayload = {
                description: 'Default list of all categories',
                isNotEditable: true,
                name: 'Full List',
            };
            yield (0, effects_1.put)(actions.createCategoryGroupListsAction(actionPayload));
        }
    }
}
function* getCategoryGroupListsSuccessActionWatcher() {
    yield (0, effects_1.takeLatest)(categoryGroupListsActions_1.getCategoryGroupListsSuccessAction, createCategoryGroupLists);
}
exports.getCategoryGroupListsSuccessActionWatcher = getCategoryGroupListsSuccessActionWatcher;
function* triggerGetCategoryGroupLists() {
    yield (0, effects_1.put)((0, categoryGroupListsActions_1.getCategoryGroupListsAction)());
}
function* createCategoryGroupListsSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.createCategoryGroupListsSuccessAction, triggerGetCategoryGroupLists);
}
exports.createCategoryGroupListsSuccessActionWatcher = createCategoryGroupListsSuccessActionWatcher;
exports.default = [
    createCategoryGroupListsActionWater,
    getCategoryGroupListsSuccessActionWatcher,
    createCategoryGroupListsSuccessActionWatcher,
];
